function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3495,17 L31.1162,0.2588 L29.3213,1.1416 L37.1204,17 L18.8796,17 L26.6787,1.1416 L24.8838,0.2588 L16.6505,17 L0,17 L0,26 L3.0248,26 L8.4721,46.0488 C8.9438,47.7866 10.5312,49 12.332,49 L43.668,49 C45.4688,49 47.0562,47.7866 47.5279,46.0488 L52.9752,26 L56,26 L56,17 L39.3495,17 Z M45.5981,45.5244 C45.3618,46.3931 44.5684,47 43.668,47 L12.332,47 C11.4316,47 10.6382,46.3931 10.4018,45.5244 L5.0977,26 L50.9024,26 L45.5981,45.5244 Z M54,24 L2,24 L2,19 L54,19 L54,24 Z",
  id: "Shape"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.121,30 L40.1403,30 C38.8411,37.8409 39.7265,32.4979 37.9864,43 L39.9671,43 C40.519,39.6683 41.6422,32.8892 42.121,30 Z",
  id: "Path"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3437,30 L31.4101,30 C30.9532,38.2734 31.1426,34.8441 30.6921,43 L32.6257,43 C33.2167,32.3004 32.9275,37.5371 33.3437,30 Z",
  id: "Path"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3079,43 C24.8431,34.5843 25.0539,38.4005 24.5899,30 L22.6562,30 C22.9336,35.0211 22.8946,34.3162 23.3742,43 L25.3079,43 Z",
  id: "Path"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0136,43 C16.9225,36.4147 16.9361,36.4968 15.8597,30 L13.8791,30 C14.0791,31.2069 15.8143,41.6804 16.033,43 L18.0136,43 Z",
  id: "Path"
});

function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atom/Icon/Brand/shopping-basket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.798e7114.svg";
export { ForwardRef as ReactComponent };